import * as angular from "angular";

export class IntegrationErrorsService {
    private apiRoot: String;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = "/v2/integration/";
    }

    all(integration: string, data?: any): Promise<object> {
        return this.$http.get(this.apiRoot + integration + "/errors", data);
    }

    push(integration: string, data?: any): Promise<object> {
        return this.$http.post(this.apiRoot + integration + "/push", data);
    }
}
angular
    .module("vcServices")
    .service("IntegrationErrorsService", IntegrationErrorsService);
